import React from "react";

interface WelcomeCardProps {
  title: string;
  description: string;
  buttonText?: string;
  imageUrl: string; // URL for the image (can be an SVG or any other image)
  additionalText?: string;
  clickFunc?: () => void;
  isEmoji?: boolean;
}

const WelcomeCard: React.FC<WelcomeCardProps> = ({
  title,
  description,
  buttonText,
  imageUrl,
  additionalText,
  clickFunc,
  isEmoji = false,
}) => {
  return (
    <div className=" p-6 py-10 sm:py-32 bg-white shadow-lg rounded-[24px] my-8 border border-gray-300">
      <div className="flex flex-col items-center">
        <div className="mb-4">
          <img
            src={imageUrl} // Use the dynamic image URL
            alt="Illustration"
            className="w-[150px] sm:w-full"
          />
        </div>
        <div className="flex items-center space-x-4">
          {/* Icon/Image */}

          <div>
            <h2 className="text-[20px] sm:text-[32px] font-bold text-fleetblue text-center">
              {isEmoji && <span>🎉</span>}
              {title}
            </h2>
            <p className="text-fleetgray mt-2 text-[14px] text-center w-full sm:w-[70%] mx-auto">
              {description}
            </p>
            {additionalText && (
              <p className="text-fleetblack text-[14px] text-center mt-2">
                {additionalText}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="mt-6 text-center">
        {buttonText && (
          <button
            onClick={clickFunc}
            className="bg-fleetyellow text-fleetblue font-semibold py-2 px-4 rounded-[8px] border border-fleetblue"
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default WelcomeCard;
